export default __webpack_public_path__ + "static/B25-ebb1e4e6b0885e51208cb507e7ab733c.png";